import { Tabs } from '@forgeglobal/design-framework';
import TabContent from '@tcs/common/components/atoms/TabContent';
import Header from '@tcs/client-portal-common/components/organisms/Header';
import AccountsOverview from '@tcs/client-portal-representative/pages/Accounts/AccountsOverview';
import AccountsReports from '@tcs/client-portal-representative/pages/Accounts/AccountsReports';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import { Route } from 'react-router';
import useIsEligibleAccounts from '@tcs/client-portal-common/hooks/useIsEligibleAccounts';

const Accounts = () => {
  const {
    claims: { clientPortalIdentity },
  } = useSession();
  const { isEligible } = useIsEligibleAccounts(clientPortalIdentity);

  return (
    <Header
      tabs={() => (
        <Tabs>
          <Route
            path="*"
            element={
              <TabContent label="Overview" data-test-id="account-overview-tab">
                <AccountsOverview />
              </TabContent>
            }
          />
          {isEligible && (
            <Route
              path="/reports"
              element={
                <TabContent label="Reports" data-test-id="accounts-reports-tab">
                  <AccountsReports representativeCode={clientPortalIdentity} />
                </TabContent>
              }
            />
          )}
        </Tabs>
      )}
      pageTitle="Accounts"
    />
  );
};

export default Accounts;
